import moment from 'moment/moment';
import React, {useEffect, useState} from 'react';
import {
   Image,
   Platform,
   ScrollView,
   StyleSheet,
   Text,
   TextInput,
   TouchableOpacity,
   View,
   Keyboard,
   NativeModules,
   Switch,
} from 'react-native';
import {CopyRight} from '../../utils/CopyRight';
import {
   appBackground,
   AUTHDATA,
   base100,
   DASHBOARD,
   MYTRAINING,
   primaryColor500,
   PROFILE,
   UPDATE_PROFILE,
   white,
   FONT_FAMILY_MEDIUM,
   FONT_FAMILY_REGULAR,
   getFirstName,
   getLastName,
   getPhoneNumaber,
   getDob,
   getEmail,
   getEmployeeKey,
   isNewAPI,
   validateEmail,
   BROUS,
   getQRCode,
   getNorcatId,
   profileTextBG,
   isWeb,
   appBackgroundWhiteBG,
   primaryState800,
   DownloadMode,
   BUTTON_HOVER_COLOR,
   BACK_BUTTON_HOVER_COLOR,
   WHITE_BUTTON_HOVER_COLOR,
   alertHandler as alertHandlers,
   isiOS,
   isWindows,
} from '../../utils/utils';
import ProfileHeader from './ProfileHeader';
import {retrieveAppData, storeAppData} from '../../utils/preference';
import {ApplicationHeader} from '../../utils/application_header';
import {useIsFocused, useNavigation} from '@react-navigation/native';
// import KeyboardAvoidingView from 'react-native/Libraries/Components/Keyboard/KeyboardAvoidingView';
import KeyboardAvoidingView from '../../components/keyboard/KeyboardAvoidingView';
import {
   apiPostRequest,
   showTokenExpireAlertWeb,
} from '../../service/network_access';
import {useDispatch, useSelector} from 'react-redux';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';
import Landscap_Application_Header from '../../utils/Landscap_Application_Header';
import DashboardRightPanel from '../dashboard/DashboardRightPanel';
import DashboardHeaderLandsacap from '../dashboard/DashboardHeaderLandsacap';
import ThreeDotsLoader from '../../utils/norcat_loading';
// import DateTimePicker from '@react-native-community/datetimepicker';
import CustomDateTimePicker from '../../components/date-picker';

import logger from '../../utils/logger';
import {selectAuthData, setSignIn} from '../../redux/slices/AuthSlice';
import {
   selectDownloadPreference,
   setDownloadPreference,
} from '../../redux/slices/DownloadPreferenceSlice';
import {
   getResponseAlertData,
   setResponseAlertData,
} from '../../redux/slices/ResponseAlertSlice';
import CustomAlert from '../../components/custom-alert/index.web';

const EditProfileScreen = () => {
   const navigation = useNavigation();
   const dispatch = useDispatch();
   const [isEmailFocused, setIsEmailFocused] = useState(false);
   const [isFirstNameFocused, setIsFirstNameFocused] = useState(false);
   const [isLastNameFocused, setIsLastNAmeFocused] = useState(false);
   const [isPhoneFocused, setIsPhoneFocused] = useState(false);
   const [isDobFocused, setIsDobFocused] = useState(false);
   const [isUsernameFocused, setIsUsernameFocused] = useState(false);
   const [email, setEmail] = useState('');
   const [firstName, setFirstName] = useState('');
   const [lastName, setLastName] = useState('');
   const [phoneNumber, setPhoneNumber] = useState('');
   const [dob, setDob] = useState('');
   const DownloadStatus = useSelector(selectDownloadPreference);
   const isLandscapemode = useSelector(selectScreenOrientation);
   const [isApiLoading, setIsApiLoading] = useState(false);
   const [openDate, setOpenDate] = useState(false);
   const [date, setDate] = useState(new Date());
   const isScreenFocused = useIsFocused();
   const authData = useSelector(selectAuthData);
   const showCancelDatePicker =
      Platform.OS === 'ios' || Platform.OS === 'macos';
   const isIOSPlatform = Platform.OS === 'ios' || Platform.OS === 'macos';
   const [isKeyboardVisible, setKeyboardVisible] = useState(false);
   const isDesktop = Platform.OS === 'macos' || Platform.OS === 'windows';
   const [isEnabled, setIsEnabled] = useState(false);
   const [cancelHover, setCalcelHover] = React.useState(false);
   const [saveHover, setSaveHover] = React.useState(false);

   const toggleSwitch = () => {
      setIsEnabled(prev => !prev);
      const check = !isEnabled ? 'true' : 'false';
      logger('check', check);
      storeAppData(DownloadMode, check);
      const preference = {downloadPreference: check};
      dispatch(setDownloadPreference(preference));
   };

   useEffect(() => {
      if ((isWindows && isScreenFocused) || !isWindows) {
         (async () => {
            setFirstName(getFirstName(authData));
            setLastName(getLastName(authData));
            setPhoneNumber(getPhoneNumaber(authData));
            setEmail(getEmail(authData));
            setDob(getDob(authData));
            setDate(new Date(getDob(authData)));
         })();
         const keyboardWillShowListener = Keyboard.addListener(
            Platform.OS === 'android' ? 'keyboardDidShow' : 'keyboardWillShow',
            () => {
               setKeyboardVisible(true);
            },
         );

         const keyboardDidHideListener = Keyboard.addListener(
            'keyboardDidHide',
            () => {
               setKeyboardVisible(false);
            },
         );
         if (isDesktop) {
            retrieveDownloadMode();
         }
         return () => {
            keyboardWillShowListener.remove();
            keyboardDidHideListener.remove();
            retrieveDownloadMode();
         };
      }
   }, []);

   const emailHandleFocus = () => {
      setIsEmailFocused(true);
   };

   const firstNameHandleFocus = () => {
      setIsFirstNameFocused(true);
   };

   const lastNAmeHandleFocus = () => {
      setIsLastNAmeFocused(true);
   };

   const phoneHandleFocus = () => {
      setIsPhoneFocused(true);
   };

   const dobHandleFocus = () => {
      setIsDobFocused(true);
   };

   const emailHandleBlur = () => {
      setIsEmailFocused(false);
   };

   const firstNameHandleBlur = () => {
      setIsFirstNameFocused(false);
   };

   const lastNAmeHandleBlur = () => {
      setIsLastNAmeFocused(false);
   };

   const phoneHandleBlur = () => {
      setIsPhoneFocused(false);
   };

   const dobHandleBlur = () => {
      setIsDobFocused(false);
   };
   /**
    * @username
    */
   const usernameHandleFocus = () => {
      setIsUsernameFocused(true);
   };
   const usernameHandleBlur = () => {
      setIsUsernameFocused(false);
   };
   const borderEmailStyle = {
      borderBottomWidth: isEmailFocused ? 3 : 0,
      borderColor: '#E2E1E1',
      borderRadius: isEmailFocused ? 0 : 6,
   };

   const borderFirstNameStyle = {
      // borderTopWidth: isFirstNameFocused ? 0 : 1,
      // borderRightWidth: isFirstNameFocused ? 0 : 1,
      // borderLeftWidth: isFirstNameFocused ? 0 : 1,
      // borderBottomWidth: isFirstNameFocused ? 3 : 1,
      // borderColor: '#AFBACA',
      // borderRadius: isFirstNameFocused ? 0 : 6,
   };

   const borderLastNameStyle = {
      // borderTopWidth: isLastNameFocused ? 0 : 1,
      // borderRightWidth: isLastNameFocused ? 0 : 1,
      // borderLeftWidth: isLastNameFocused ? 0 : 1,
      // borderBottomWidth: isLastNameFocused ? 3 : 1,
      // borderColor: '#AFBACA',
      // borderRadius: isLastNameFocused ? 0 : 6,
   };

   const borderPhoneStyle = {
      borderBottomWidth: isPhoneFocused ? 3 : 0,
      borderColor: '#E2E1E1',
      borderRadius: isPhoneFocused ? 0 : 6,
   };

   const borderDobStyle = {
      borderTopWidth: isDobFocused ? 0 : 1,
      borderRightWidth: isDobFocused ? 0 : 1,
      borderLeftWidth: isDobFocused ? 0 : 1,
      borderBottomWidth: isDobFocused ? 3 : 1,
      borderColor: '#AFBACA',
      borderRadius: isDobFocused ? 0 : 6,
   };
   const borderUserNameStyle = {
      borderTopWidth: isUsernameFocused ? 0 : 0,
      borderRightWidth: isUsernameFocused ? 0 : 0,
      borderLeftWidth: isUsernameFocused ? 0 : 0,
      borderBottomWidth: isUsernameFocused ? 3 : 0,
      borderColor: '#E2E1E1',
      borderRadius: isUsernameFocused ? 0 : 6,
   };

   const disabled = {
      backgroundColor: '#F3F3F3',
      borderColor: '#F3F3F3',
      height: 48,
      opacity: 0.5,
      justifyContent: 'center',
   };

   const onDateSelect = (event, selectedDate) => {
      logger({event, selectedDate});
      if (!isIOSPlatform && Platform.OS !== 'web') {
         setOpenDate(false);
      }
      setDate(selectedDate);
      setDob(selectedDate);
   };
   const onDateSelectWeb = selectedDate => {
      setDate(selectedDate);
      setDob(selectedDate);
      setOpenDate(false);
   };

   const handlePhoneNumberChange = text => {
      // Remove all non-numeric characters from the input
      const formattedPhoneNumber = text.replace(/[^0-9()+-]/g, '');
      setPhoneNumber(formattedPhoneNumber);
   };

   useEffect(() => {
      if (isDesktop) {
         retrieveDownloadMode();
         return () => {
            retrieveDownloadMode();
         };
      }
   }, [DownloadStatus, isDesktop]);

   const retrieveDownloadMode = async () => {
      const storeData = await retrieveAppData(DownloadMode);
      const downloadStatus = storeData === 'true';
      setIsEnabled(downloadStatus);
   };

   return (
      <>
         {Platform.OS === 'web' && isLandscapemode ? (
            <View
               style={[
                  styles.container,
                  {
                     ...Platform.select({
                        web: {
                           flex: null,
                           height: '100vh',
                           overflowY: isLandscapemode ? 'hidden' : null,
                        },
                     }),
                  },
               ]}>
               {!isLandscapemode ? (
                  <ApplicationHeader
                     OnBackPress={() => {
                        navigation.goBack();
                     }}
                     title="Profile"
                  />
               ) : (
                  <Landscap_Application_Header
                     authData={authData}
                     selectedTab={PROFILE}
                     onTopMenuClick={value => {
                        if (value === DASHBOARD) {
                           navigation.navigate('DashboardScreen');
                        } else if (value === MYTRAINING) {
                           navigation.navigate('MyTraningScreen');
                        } else if (value === PROFILE) {
                           navigation.navigate('ProfileScreen');
                        } else if (value === BROUS) {
                           navigation.navigate('BrowsesCoursesScreen');
                        }
                     }}
                  />
               )}
               <View
                  style={{
                     flexDirection: 'row',
                     flex: 1,
                     ...Platform.select({
                        web: {
                           minHeight: 500,
                        },
                     }),
                  }}>
                  <View style={{flex: 1}}>
                     <DashboardHeaderLandsacap
                        subtitle={authData.CompanyName}
                        icon={require('../../assets/user.png')}
                        title="My Profile"
                        showCourses={false}
                        showSearchView={false}
                        showFilterTabs={false}
                        showRecordTabs={false}
                        showFooter={true}
                        showRefreshIcon={false}
                        authData={authData}
                     />
                     {isApiLoading ? (
                        <View style={{flex: 1}}>
                           <ThreeDotsLoader title={''} />
                        </View>
                     ) : (
                        <View style={styles.profileStyleLandscap}>
                           <View
                              style={{
                                 flexDirection: 'column',
                                 flex: 1,
                                 marginEnd: 16,
                              }}>
                              <Text style={styles.titleStyle}>First Name</Text>
                              <TextInput
                                 style={[
                                    styles.inputStyle,
                                    borderFirstNameStyle,
                                    disabled,
                                 ]}
                                 value={firstName}
                                 maxLength={25}
                                 onChangeText={text => {
                                    if (text.length <= 25) {
                                       setFirstName(text);
                                    }
                                 }}
                                 onFocus={firstNameHandleFocus}
                                 onBlur={firstNameHandleBlur}
                                 editable={false}
                              />
                              <Text style={styles.titleStyle}>User Name</Text>
                              <TextInput
                                 style={[
                                    styles.inputStyle,
                                    borderUserNameStyle,
                                 ]}
                                 value={email}
                                 maxLength={50}
                                 onChangeText={text => {
                                    if (text.length <= 50) {
                                       setEmail(text);
                                    }
                                 }}
                                 onFocus={usernameHandleFocus}
                                 onBlur={usernameHandleBlur}
                              />
                              <Text style={styles.titleStyle}>
                                 Phone Number
                              </Text>
                              <TextInput
                                 style={[styles.inputStyle, borderPhoneStyle]}
                                 onFocus={phoneHandleFocus}
                                 onBlur={phoneHandleBlur}
                                 keyboardType="numeric"
                                 maxLength={25}
                                 onChangeText={handlePhoneNumberChange}
                                 value={phoneNumber}
                              />
                           </View>
                           <View
                              style={{
                                 flexDirection: 'column',
                                 flex: 1,
                                 marginStart: 16,
                              }}>
                              <Text style={styles.titleStyle}>Last Name</Text>
                              <TextInput
                                 style={[
                                    styles.inputStyle,
                                    borderLastNameStyle,
                                    disabled,
                                 ]}
                                 value={lastName}
                                 maxLength={25}
                                 onChangeText={text => {
                                    if (text.length <= 25) {
                                       setLastName(text);
                                    }
                                 }}
                                 onFocus={lastNAmeHandleFocus}
                                 onBlur={lastNAmeHandleBlur}
                                 editable={false}
                              />
                              <Text style={styles.titleStyle}>Email</Text>
                              <TextInput
                                 style={[styles.inputStyle, borderEmailStyle]}
                                 value={email}
                                 onFocus={emailHandleFocus}
                                 onChangeText={text => setEmail(text)}
                                 onBlur={emailHandleBlur}
                              />
                              <Text style={styles.titleStyle}>
                                 Date of Birth
                              </Text>
                              <View>
                                 <View
                                    style={[
                                       styles.inputStyle,
                                       {justifyContent: 'center'},
                                       Platform.OS === 'web'
                                          ? styles.dobInputStyle
                                          : null,
                                    ]}>
                                    <CustomDateTimePicker
                                       testID="dateTimePicker"
                                       // value={date}
                                       textColor="#000"
                                       // onChange={onDateSelect}
                                       // onCancel={() => {}}
                                       // styleClass={styles.datePicker}
                                       maximumDate={new Date()}
                                       selectedDate={date}
                                       setSelectedDate={setDate}
                                       onDateSelect={onDateSelectWeb}
                                    />
                                 </View>
                              </View>
                           </View>
                        </View>
                     )}
                     {!isApiLoading && (
                        <View
                           style={{
                              flexDirection: 'row-reverse',
                              paddingVertical: 16,
                              paddingHorizontal: 16,
                           }}>
                           <TouchableOpacity
                              style={{
                                 backgroundColor: saveHover
                                    ? BUTTON_HOVER_COLOR
                                    : primaryColor500,
                                 minHeight: 48,
                                 paddingHorizontal: 16,
                                 borderRadius: 6,
                                 justifyContent: 'center',
                              }}
                              onMouseEnter={() => {
                                 setSaveHover(true);
                              }}
                              onMouseLeave={() => {
                                 setSaveHover(false);
                              }}
                              onPress={() => {
                                 UpdateUserProfile();
                              }}>
                              <View
                                 style={{
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignContent: 'center',
                                    alignItems: 'center',
                                 }}>
                                 <Text
                                    style={{
                                       color: 'white',
                                       fontSize: 16,
                                       fontWeight: '500',
                                       textAlign: 'center',
                                       fontFamily: FONT_FAMILY_MEDIUM,
                                    }}>
                                    Save Changes
                                 </Text>
                                 <Image
                                    source={require('../../assets/double_tick.png')}
                                    style={{
                                       marginStart: 10,
                                       width: 17,
                                       height: 10,
                                    }}
                                 />
                              </View>
                           </TouchableOpacity>
                           <TouchableOpacity
                              style={{
                                 backgroundColor: white,
                                 backgroundColor: cancelHover
                                    ? WHITE_BUTTON_HOVER_COLOR
                                    : white,
                                 minHeight: 48,
                                 paddingHorizontal: 16,
                                 borderRadius: 6,
                                 borderColor: primaryColor500,
                                 borderWidth: 1,
                                 justifyContent: 'center',
                                 marginEnd: 16,
                              }}
                              onMouseEnter={() => {
                                 setCalcelHover(true);
                              }}
                              onMouseLeave={() => {
                                 setCalcelHover(false);
                              }}
                              onPress={() => {
                                 navigation.goBack();
                              }}>
                              <View
                                 style={{
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignContent: 'center',
                                    alignItems: 'center',
                                 }}>
                                 <Text
                                    style={{
                                       color: primaryColor500,
                                       fontSize: 16,
                                       fontWeight: '500',
                                       textAlign: 'center',
                                       fontFamily: FONT_FAMILY_MEDIUM,
                                    }}>
                                    Cancel
                                 </Text>
                                 <Image
                                    source={require('../../assets/cross.png')}
                                    style={{
                                       marginStart: 10,
                                       tintColor: '#003DA5',
                                       height: 13,
                                       width: 13,
                                    }}
                                 />
                              </View>
                           </TouchableOpacity>
                        </View>
                     )}
                     <CopyRight
                        screenOrientation={isLandscapemode}
                        isCopyrightShown={!isKeyboardVisible}
                     />
                  </View>
                  <View
                     style={{
                        flex: 0.4,
                        ...Platform.select({
                           web: {
                              flex: isLandscapemode ? null : 0.4,
                              width: isLandscapemode ? '30%' : null,
                              height: isLandscapemode ? '90vh' : null,
                           },
                        }),
                     }}>
                     <DashboardRightPanel
                        showProgressView={false}
                        showName={false}
                        authData={authData}
                        maxHeight="83%"
                        onQrClick={() => {
                           navigation.navigate('QRAndBarcodeScreen', {
                              norcatID: getNorcatId(authData),
                              qrID: getQRCode(authData),
                           });
                        }}
                     />
                  </View>
               </View>
            </View>
         ) : (
            <KeyboardAvoidingView
               behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
               style={styles.container}>
               <View style={styles.container}>
                  {!isLandscapemode ? (
                     <ApplicationHeader
                        OnBackPress={() => {
                           navigation.goBack();
                        }}
                        title="Profile"
                     />
                  ) : (
                     <Landscap_Application_Header
                        authData={authData}
                        selectedTab={PROFILE}
                        onTopMenuClick={value => {
                           if (value === DASHBOARD) {
                              navigation.navigate('DashboardScreen');
                           } else if (value === MYTRAINING) {
                              navigation.navigate('MyTraningScreen');
                           } else if (value === PROFILE) {
                              navigation.navigate('ProfileScreen');
                           } else if (value === BROUS) {
                              navigation.navigate('BrowsesCoursesScreen');
                           }
                        }}
                        dataSource={['Logout']}
                     />
                  )}
                  {!isLandscapemode ? (
                     <View
                        style={{
                           flex: 1,
                           ...Platform.select({
                              web: {
                                 flex: null,
                                 height: '90vh',
                              },
                           }),
                        }}>
                        <ProfileHeader
                           title="Account Details"
                           subTitle={authData.CompanyName}
                           icon={require('../../assets/userIcon.png')}
                           authData={authData}
                           onQrClick={() => {
                              // To do , uncomment below line and remove handlePress(); call
                              navigation.navigate('QRAndBarcodeScreen', {
                                 norcatID: getNorcatId(authData),
                                 qrID: getQRCode(authData),
                              });
                           }}
                        />
                        {isApiLoading ? (
                           <View
                              style={{
                                 flex: 1,
                              }}>
                              <ThreeDotsLoader title={''} />
                           </View>
                        ) : (
                           <ScrollView style={{flex: 1, marginBottom: 16}}>
                              <View style={styles.profileStyle}>
                                 <Text style={styles.titleStyle}>
                                    First Name
                                 </Text>
                                 <TextInput
                                    style={[
                                       styles.inputStyle,
                                       borderFirstNameStyle,
                                       disabled,
                                    ]}
                                    value={firstName}
                                    maxLength={25}
                                    onChangeText={text => {
                                       if (text.length <= 25) {
                                          setFirstName(text);
                                       }
                                    }}
                                    onFocus={firstNameHandleFocus}
                                    onBlur={firstNameHandleBlur}
                                    editable={false}
                                 />
                                 <Text style={styles.titleStyle}>
                                    Last Name
                                 </Text>
                                 <TextInput
                                    style={[
                                       styles.inputStyle,
                                       borderLastNameStyle,
                                       disabled,
                                    ]}
                                    value={lastName}
                                    maxLength={25}
                                    onChangeText={text => {
                                       if (text.length <= 25) {
                                          setLastName(text);
                                       }
                                    }}
                                    onFocus={lastNAmeHandleFocus}
                                    onBlur={lastNAmeHandleBlur}
                                    editable={false}
                                 />
                                 <Text style={styles.titleStyle}>Username</Text>
                                 <TextInput
                                    style={[
                                       styles.inputStyle,
                                       borderEmailStyle,
                                    ]}
                                    value={email}
                                    maxLength={50}
                                    onFocus={emailHandleFocus}
                                    onChangeText={text => {
                                       if (text.length <= 50) {
                                          setEmail(text);
                                       }
                                    }}
                                    onBlur={emailHandleBlur}
                                 />
                                 <Text style={styles.titleStyle}>
                                    Date of Birth
                                 </Text>
                                 <TouchableOpacity
                                    onPress={() => {
                                       Platform.OS !== 'web' &&
                                          setOpenDate(true);
                                    }}>
                                    <View
                                       style={[
                                          styles.inputStyle,
                                          Platform.OS === 'web'
                                             ? styles.dobInputStyle
                                             : null,
                                       ]}>
                                       {Platform.OS === 'web' ? (
                                          <CustomDateTimePicker
                                             testID="dateTimePicker"
                                             // value={date}
                                             // textColor="#000"
                                             // onChange={onDateSelect}
                                             // onCancel={() => {}}
                                             // styleClass={styles.datePicker}
                                             maximumDate={new Date()}
                                             selectedDate={date}
                                             setSelectedDate={setDate}
                                             onDateSelect={onDateSelectWeb}
                                          />
                                       ) : (
                                          <Text style={styles.textStyle}>
                                             {formateDate(dob)}
                                          </Text>
                                       )}
                                    </View>
                                 </TouchableOpacity>
                                 <Text style={styles.titleStyle}>
                                    Phone Number
                                 </Text>
                                 <TextInput
                                    style={[
                                       styles.inputStyle,
                                       borderPhoneStyle,
                                    ]}
                                    onFocus={phoneHandleFocus}
                                    onBlur={phoneHandleBlur}
                                    keyboardType="phone-pad"
                                    onChangeText={handlePhoneNumberChange}
                                    maxLength={25}
                                    value={phoneNumber}
                                 />
                              </View>
                           </ScrollView>
                        )}
                        {!isApiLoading ? (
                           <View style={{paddingHorizontal: 14}}>
                              <TouchableOpacity
                                 style={{
                                    backgroundColor: cancelHover
                                       ? BACK_BUTTON_HOVER_COLOR
                                       : primaryColor500,
                                    minHeight: 48,
                                    marginVertical: isLandscapemode ? 50 : 10,
                                    marginHorizontal: 16,
                                    borderRadius: 6,
                                    width: isLandscapemode ? 150 : '100%',
                                    justifyContent: 'center',
                                    alignSelf: 'center',
                                    marginBottom:
                                       isLandscapemode && !isiOS ? null : 16,
                                 }}
                                 onMouseEnter={() => {
                                    setCalcelHover(true);
                                 }}
                                 onMouseLeave={() => {
                                    setCalcelHover(false);
                                 }}
                                 onPress={() => {
                                    UpdateUserProfile();
                                 }}>
                                 <View
                                    style={{
                                       flexDirection: 'row',
                                       justifyContent: 'center',
                                       alignContent: 'center',
                                       alignItems: 'center',
                                    }}>
                                    <Text
                                       style={{
                                          color: 'white',
                                          fontSize: 16,
                                          fontWeight: '500',
                                          textAlign: 'center',
                                          fontFamily: FONT_FAMILY_MEDIUM,
                                       }}>
                                       Save Changes
                                    </Text>
                                    <Image
                                       source={require('../../assets/double_tick.png')}
                                       style={{
                                          marginStart: 10,
                                          width: 17,
                                          height: 10,
                                       }}
                                    />
                                 </View>
                              </TouchableOpacity>
                           </View>
                        ) : null}
                     </View>
                  ) : (
                     <View style={{flexDirection: 'row', flex: 1}}>
                        <View style={{flex: 1}}>
                           <DashboardHeaderLandsacap
                              subtitle={authData.CompanyName}
                              icon={require('../../assets/user.png')}
                              title="My Profile"
                              showCourses={false}
                              showSearchView={false}
                              showFilterTabs={false}
                              showRecordTabs={false}
                              showFooter={true}
                              showRefreshIcon={false}
                              authData={authData}
                           />
                           {isApiLoading ? (
                              <View style={{flex: 1}}>
                                 <ThreeDotsLoader title={''} />
                              </View>
                           ) : (
                              <View style={styles.profileStyleLandscap}>
                                 <View
                                    style={{
                                       flexDirection: 'column',
                                       flex: 1,
                                       marginEnd: 16,
                                    }}>
                                    <Text style={styles.titleStyle}>
                                       First Name
                                    </Text>
                                    <TextInput
                                       style={[
                                          styles.inputStyle,
                                          {opacity: 0.6},
                                       ]}
                                       value={firstName}
                                       maxLength={25}
                                       onChangeText={text => {
                                          if (text.length <= 25) {
                                             setFirstName(text);
                                          }
                                       }}
                                       onFocus={firstNameHandleFocus}
                                       onBlur={firstNameHandleBlur}
                                       editable={false}
                                    />
                                    <Text style={styles.titleStyle}>
                                       User Name
                                    </Text>
                                    <TextInput
                                       style={[styles.inputStyle]}
                                       value={email}
                                       maxLength={50}
                                       onChangeText={text => {
                                          if (text.length <= 50) {
                                             setEmail(text);
                                          }
                                       }}
                                       onFocus={emailHandleFocus}
                                       onBlur={emailHandleBlur}
                                    />
                                    <Text style={styles.titleStyle}>
                                       Phone Number
                                    </Text>
                                    <TextInput
                                       style={[
                                          styles.inputStyle,
                                          borderPhoneStyle,
                                       ]}
                                       onFocus={phoneHandleFocus}
                                       onBlur={phoneHandleBlur}
                                       keyboardType="numeric"
                                       onChangeText={handlePhoneNumberChange}
                                       maxLength={25}
                                       value={phoneNumber}
                                    />
                                 </View>
                                 <View
                                    style={{
                                       flexDirection: 'column',
                                       flex: 1,
                                       marginStart: 16,
                                    }}>
                                    <Text style={styles.titleStyle}>
                                       Last Name
                                    </Text>
                                    <TextInput
                                       style={[
                                          styles.inputStyle,
                                          {opacity: 0.6},
                                       ]}
                                       value={lastName}
                                       maxLength={25}
                                       onChangeText={text => {
                                          if (text.length <= 25) {
                                             setLastName(text);
                                          }
                                       }}
                                       onFocus={lastNAmeHandleFocus}
                                       onBlur={lastNAmeHandleBlur}
                                       editable={false}
                                    />
                                    <Text style={styles.titleStyle}>Email</Text>
                                    <TextInput
                                       style={[
                                          styles.inputStyle,
                                          borderEmailStyle,
                                       ]}
                                       value={email}
                                       onFocus={emailHandleFocus}
                                       maxLength={50}
                                       onChangeText={text => {
                                          if (text.length <= 50) {
                                             setEmail(text);
                                          }
                                       }}
                                       onBlur={emailHandleBlur}
                                    />
                                    <Text style={styles.titleStyle}>
                                       Date of Birth
                                    </Text>
                                    <TouchableOpacity
                                       onPress={event => {
                                          if (Platform.OS === 'macos') {
                                             NativeModules.DatePickerModule.showDatePicker(
                                                moment(dob).format(
                                                   'YYYY-MM-DD',
                                                ),
                                                event.nativeEvent.pageX,
                                                event.nativeEvent.pageY,
                                                selectedDate => {
                                                   logger('date', selectedDate);
                                                   setDate(selectedDate);
                                                   setDob(selectedDate);
                                                },
                                             );
                                          } else {
                                             setOpenDate(true);
                                          }
                                       }}>
                                       <View style={styles.inputStyle}>
                                          <Text style={styles.textStyle}>
                                             {formateDate(dob)}
                                          </Text>
                                       </View>
                                    </TouchableOpacity>
                                 </View>
                              </View>
                           )}
                           {!isApiLoading && (
                              <View
                                 style={{
                                    flexDirection: 'row-reverse',
                                    paddingVertical: 16,
                                    paddingHorizontal: 16,
                                 }}>
                                 <TouchableOpacity
                                    style={{
                                       backgroundColor: saveHover
                                          ? BUTTON_HOVER_COLOR
                                          : primaryColor500,
                                       minHeight: 48,
                                       paddingHorizontal: 16,
                                       borderRadius: 6,
                                       justifyContent: 'center',
                                    }}
                                    onMouseEnter={() => {
                                       setSaveHover(true);
                                    }}
                                    onMouseLeave={() => {
                                       setSaveHover(false);
                                    }}
                                    onPress={() => {
                                       UpdateUserProfile();
                                    }}>
                                    <View
                                       style={{
                                          flexDirection: 'row',
                                          justifyContent: 'center',
                                          alignContent: 'center',
                                          alignItems: 'center',
                                       }}>
                                       <Text
                                          style={{
                                             color: 'white',
                                             fontSize: 16,
                                             fontWeight: '500',
                                             textAlign: 'center',
                                             fontFamily: FONT_FAMILY_MEDIUM,
                                          }}>
                                          Save Changes
                                       </Text>
                                       <Image
                                          source={require('../../assets/double_tick.png')}
                                          style={{
                                             marginStart: 10,
                                             width: 17,
                                             height: 10,
                                          }}
                                       />
                                    </View>
                                 </TouchableOpacity>
                                 <TouchableOpacity
                                    style={{
                                       backgroundColor: white,
                                       minHeight: 48,
                                       backgroundColor: cancelHover
                                          ? WHITE_BUTTON_HOVER_COLOR
                                          : white,
                                       paddingHorizontal: 16,
                                       borderRadius: 6,
                                       borderColor: primaryColor500,
                                       borderWidth: 1,
                                       justifyContent: 'center',
                                       marginEnd: 16,
                                    }}
                                    onMouseEnter={() => {
                                       setCalcelHover(true);
                                    }}
                                    onMouseLeave={() => {
                                       setCalcelHover(false);
                                    }}
                                    onPress={() => {
                                       navigation.goBack();
                                    }}>
                                    <View
                                       style={{
                                          flexDirection: 'row',
                                          justifyContent: 'center',
                                          alignContent: 'center',
                                          alignItems: 'center',
                                       }}>
                                       <Text
                                          style={{
                                             color: primaryColor500,
                                             fontSize: 16,
                                             fontWeight: '500',
                                             textAlign: 'center',
                                             fontFamily: FONT_FAMILY_MEDIUM,
                                          }}>
                                          Cancel
                                       </Text>
                                       <Image
                                          source={require('../../assets/cross.png')}
                                          style={{
                                             marginStart: 10,
                                             tintColor: '#003DA5',
                                             height: 13,
                                             width: 13,
                                          }}
                                       />
                                    </View>
                                 </TouchableOpacity>
                                 {isDesktop && (
                                    <View style={{flex: 1}}>
                                       <Text style={styles.downloadTitleStyle}>
                                          {
                                             '"Enable Download" (Opt this option to access courses offline)'
                                          }
                                       </Text>
                                    </View>
                                 )}
                                 {isDesktop && (
                                    <View
                                       style={{
                                          marginTop: 5,
                                          minHeight: 48,
                                       }}>
                                       <Switch
                                          onValueChange={toggleSwitch}
                                          trackColor={{
                                             false: 'gray',
                                             true: '#003DA5',
                                          }}
                                          thumbColor={
                                             isEnabled ? 'white' : 'lightgray'
                                          }
                                          value={isEnabled}
                                       />
                                    </View>
                                 )}
                              </View>
                           )}
                           <CopyRight
                              screenOrientation={isLandscapemode}
                              isCopyrightShown={!isKeyboardVisible}
                           />
                        </View>
                        <View
                           style={{
                              flex: 0.4,
                              ...Platform.select({
                                 web: {
                                    flex: isLandscapemode ? null : 0.4,
                                    width: isLandscapemode ? '30%' : null,
                                    height: isLandscapemode ? '90vh' : null,
                                 },
                              }),
                           }}>
                           <DashboardRightPanel
                              showProgressView={false}
                              showName={false}
                              authData={authData}
                              onQrClick={() => {
                                 navigation.navigate('QRAndBarcodeScreen', {
                                    norcatID: getNorcatId(authData),
                                    qrID: getQRCode(authData),
                                 });
                              }}
                           />
                        </View>
                     </View>
                  )}
                  {openDate && (
                     <TouchableOpacity
                        style={styles.overlay}
                        onPress={() => {
                           setOpenDate(false);
                        }}>
                        <View style={{backgroundColor: 'black'}}>
                           <CustomDateTimePicker
                              testID="dateTimePicker"
                              value={date}
                              is24Hour
                              textColor="#ffffff"
                              display={
                                 Platform.OS === 'ios' ? 'spinner' : 'default'
                              }
                              onChange={onDateSelect}
                              onCancel={() => {}}
                              style={styles.datePicker}
                              maximumDate={new Date()}
                              selectedDate={date}
                              setSelectedDate={setDate}
                              onDateSelect={onDateSelect}
                           />
                        </View>
                     </TouchableOpacity>
                  )}
               </View>
            </KeyboardAvoidingView>
         )}
      </>
   );

   function UpdateUserProfile() {
      if (!firstName.trim()) {
         alertHandler('Please enter first name.', 'NO_BACK');
         return;
      }
      if (!lastName.trim()) {
         alertHandler('Please enter last name.', 'NO_BACK');
         return;
      }

      if (!email.trim()) {
         alertHandler('Please enter email.', 'NO_BACK');
         return;
      }

      if (!validateEmail(email)) {
         alertHandler('Please enter valid email.', 'NO_BACK');
         setWebAlert(dispatch, res?.StatusMessage);
         return;
      }

      if (!phoneNumber.trim()) {
         alertHandler('Please enter phone number.', 'NO_BACK');
         return;
      }

      if (phoneNumber.length > 25) {
         alertHandler('Please enter valid phone number.', 'NO_BACK');
         return;
      }
      setIsApiLoading(true);
      const reqParms = {
         theData: JSON.stringify({
            EmployeeKey: getEmployeeKey(authData),
            FirstName: firstName,
            LastName: lastName,
            Email: email,
            DateOfBirth: moment(dob).format('MMM DD, yyyy'),
            PhoneNumber: encodeURIComponent(phoneNumber),
         }),
      };
      logger(reqParms);
      setIsApiLoading(true);
      apiPostRequest({url: UPDATE_PROFILE, parms: reqParms})
         .then(res => {
            setIsApiLoading(false);
            // setIsApiLoading(false);
            if (res && res.StatusResult) {
               logger('Success Response:: ' + res);
               // const user = {
               //   isLoggedIn: true,
               //   userName: res.ACMEmployeeFirstName,
               // };
               const clonedObject = JSON.parse(JSON.stringify(authData));

               if (isNewAPI) {
                  clonedObject.FirstName = firstName;
                  clonedObject.LastName = lastName;
                  clonedObject.PhoneNumber = phoneNumber;
                  clonedObject.EmailAddress = email;
                  clonedObject.DateOfBirth = dob.toString();
               } else {
                  clonedObject.ACMEmployeeFirstName = firstName;
                  clonedObject.ACMEmployeeLastName = lastName;
                  clonedObject.ACMEmployeePhone = phoneNumber;
                  clonedObject.ACMEmployeeEmail = email;
                  clonedObject.DoB = dob.toString();
               }
               storeAppData(AUTHDATA, JSON.stringify(clonedObject));
               const user = {
                  isLoggedIn: true,
                  userName: firstName,
                  authData: clonedObject,
               };
               dispatch(setSignIn(user));
               //navigation.goBack();
               //alert(res.StatusMessage);
               alertHandler(res?.StatusMessage);
               // dispatch(setSignIn(user));
            } else if (typeof res === 'string') {
               logger('Exception Response:: ' + res);
               if (isWeb) {
                  showTokenExpireAlertWeb(res);
               } else {
                  alert(res);
               }
               // setIsError(true);
               // setErrorMessage(res);
            } else {
               logger('Error Response:: ' + JSON.stringify(res));
               // setIsError(true);
               // setErrorMessage('Please verify your login credential');
            }
         })
         .catch(error => {
            logger('error::', error);
         });
   }

   function alertHandler(message, callbackType = 'GO_BACK') {
      if (isWeb) {
         alertHandlers(dispatch, setResponseAlertData, message, callbackType);
      } else {
         alert(message);
      }
   }
};

function formateDate(date) {
   return moment(date).format('MM-DD-YYYY');
}

const styles = StyleSheet.create({
   container: {backgroundColor: white, flex: 1, paddingBottom: isWeb ? 10 : 0},
   inputStyle: {
      width: '100%',
      backgroundColor: profileTextBG,
      marginTop: 8,
      borderWidth: 0,
      paddingHorizontal: 14,
      borderColor: profileTextBG,
      borderRadius: 6,
      fontSize: 14,
      maxHeight: 40,
      minHeight: 40,
      padding: 10,
      textAlignVertical: 'center',
      color: base100,
      fontWeight: '700',
      fontFamily: FONT_FAMILY_REGULAR,
   },
   dobInputStyle: {
      padding: 0,
      paddingHorizontal: 0,
      backgroundColor: '#F3F3F3',
   },
   titleStyle: {
      fontSize: 14,
      marginTop: 16,
      color: '#000000',
      fontWeight: '600',
      fontFamily: FONT_FAMILY_REGULAR,
   },
   profileStyle: {
      paddingHorizontal: 16,
      paddingVertical: 8,
      flexDirection: 'column',
   },
   profileStyleLandscap: {
      paddingHorizontal: 16,
      paddingVertical: 8,
      flexDirection: 'row',
   },
   textStyle: {
      fontSize: 14,
      color: base100,
      fontWeight: '700',
      fontFamily: FONT_FAMILY_REGULAR,
   },
   overlay: {
      ...StyleSheet.absoluteFillObject,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      justifyContent: 'center',
      alignItems: 'center',
   },
   datePicker: {
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
      color: '#000',
   },
   downloadTitleStyle: {
      fontSize: 14,
      marginTop: 10,
      color: primaryState800,
      fontWeight: '500',
      fontFamily: FONT_FAMILY_REGULAR,
      lineHeight: 24,
      letterSpacing: -0.3,
   },
});

export default EditProfileScreen;
